
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import store from '@/store/index';

@Component({
    name: 'WechatPopup',
})
export default class WechatPopup extends Vue {
    public visible = false;
    public get storeVisible() {
        return store.state.util.wechatPopupVisible;
    }
    public get activityId() {
        return this.$route.params.activityId || store.getters['activity/activityId'];
    }
    // 赛事基础信息
    public get activityBasicInfo() {
        return store.state.activity.basicInfo[this.activityId];
    }
    public get enterCode() {
        return this.activityBasicInfo?.enterprise_code;
    }

    @Watch('storeVisible')
    public watchstoreVisible() {
        this.visible = this.storeVisible;
    }

    public close() {
        this.visible = false;
        store.commit('setWechatPopupVisible', false);
    }
}
